import { MenuItem } from '../models/menu/menu.model';

export const metMenu: MenuItem[] = [];
